import uuid from "uuidv4";
import { UUID } from "common-types";

export interface ILeaderboardInput {
  title: string;
}

export interface ILeaderboard extends ILeaderboardInput {
  id: UUID;
}

export interface ITeamInput {
  name: string;
}

export interface ITeam extends ITeamInput {
  id: UUID;
}

export interface IPlayerInput {
  firstName: string;
  lastName: string;
  coursePlayed: string;
  teamId: UUID;
  handicap: number;
  score: number; // between 1-100
  leaderboardId: UUID;
}

export interface IPlayer extends IPlayerInput {
  id: UUID;
}

export interface IStoreState {
  players: IPlayer[];
  leaderboards: ILeaderboard[];
  teams: ITeam[];
}

export const defaultStoreState: IStoreState = {
  players: [],
  leaderboards: [],
  teams: [],
};

export const createLeaderboard = (leaderboardInput: ILeaderboardInput): ILeaderboard => ({
  id: uuid(),
  ...leaderboardInput,
});

export const editLeaderboard = (
  leaderboard: ILeaderboard,
  leaderboardInput: ILeaderboardInput
): ILeaderboard => ({
  ...leaderboard,
  ...leaderboardInput,
});

export const deleteLeaderboard = (
  id: UUID,
  leaderboards: ILeaderboard[]
): ILeaderboard[] => (
    leaderboards.filter(leaderboard => leaderboard.id !== id)
  );

export const createTeam = (teamInput: ITeamInput): ITeam => ({
  id: uuid(),
  ...teamInput,
});

export const editTeam = (
  team: ITeam,
  teamInput: ITeamInput
): ITeam => ({
  ...team,
  ...teamInput
});

export const deleteTeam = (
  id: UUID,
  teams: ITeam[]
): ITeam[] => (
    teams.filter(team => team.id !== id)
  );

export const createPlayer = (playerInput: IPlayerInput): IPlayer => ({
  id: uuid(),
  ...playerInput,
});

export const editPlayer = (
  player: IPlayer,
  playerInput: IPlayerInput
): IPlayer => ({
  ...player,
  ...playerInput,
});

export const deletePlayer = (
  id: UUID,
  players: IPlayer[]
): IPlayer[] => (
    players.filter(player => player.id !== id)
  );

export const deleteLeaderboardPlayers = (
  leaderboardId: UUID,
  players: IPlayer[]
): IPlayer[] => (
    players.filter(player => player.leaderboardId !== leaderboardId)
  );